var _g, _g2, _g3, _g4, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStats3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "profit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.223,
    height: 52.224,
    viewBox: "0 0 52.223 52.224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_98085",
    "data-name": "Group 98085",
    transform: "translate(24.581 18.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98084",
    "data-name": "Group 98084"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215403",
    "data-name": "Path 215403",
    d: "M254.77,181a13.77,13.77,0,1,0,13.872,13.77A13.785,13.785,0,0,0,254.77,181Zm1.57,21.143c-.013,0-.027,0-.04.007v1.8a1.53,1.53,0,0,1-3.06,0v-1.81a6.292,6.292,0,0,1-2.8-1.971,1.529,1.529,0,1,1,2.343-1.966,2.359,2.359,0,0,0,2.509,1.065,1.531,1.531,0,0,0-.523-2.969,4.591,4.591,0,0,1-1.788-8.818c.084-.036.173-.034.258-.064v-1.828a1.53,1.53,0,1,1,3.06,0v1.83a5.909,5.909,0,0,1,2.255,1.361,1.53,1.53,0,0,1-2.131,2.2,2.09,2.09,0,0,0-2.249-.678,1.53,1.53,0,0,0,.595,2.94,4.59,4.59,0,0,1,1.57,8.9Z",
    transform: "translate(-241 -181.005)",
    fill: "#00057d"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_98087",
    "data-name": "Group 98087",
    transform: "translate(0 33.762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98086",
    "data-name": "Group 98086"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215404",
    "data-name": "Path 215404",
    d: "M1.534,331A1.529,1.529,0,0,0,0,332.533v15.4a1.529,1.529,0,0,0,1.53,1.53h4.59V331Z",
    transform: "translate(-0.004 -331.003)",
    fill: "#00057d"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_98089",
    "data-name": "Group 98089",
    transform: "translate(12.342 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98088",
    "data-name": "Group 98088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215405",
    "data-name": "Path 215405",
    d: "M144.948,9.549,134.238.369a1.524,1.524,0,0,0-1.99,0l-10.71,9.18a1.53,1.53,0,0,0,1,2.691h4.59V52.223h10.71a1.529,1.529,0,0,0,1.53-1.53V47.2a16.8,16.8,0,0,1,0-29.943V12.24h4.59a1.53,1.53,0,0,0,1-2.691Z",
    transform: "translate(-121.003 0.001)",
    fill: "#00057d"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_98091",
    "data-name": "Group 98091",
    transform: "translate(9.282 21.522)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98090",
    "data-name": "Group 98090"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_215406",
    "data-name": "Path 215406",
    d: "M92.532,211.005a1.529,1.529,0,0,0-1.53,1.53v29.171h6.12v-30.7Z",
    transform: "translate(-91.002 -211.005)",
    fill: "#00057d"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_889",
    "data-name": "Ellipse 889",
    cx: 11.5,
    cy: 11,
    rx: 11.5,
    ry: 11,
    transform: "translate(27.118 20.77)",
    fill: "#00057d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats3);
export default __webpack_public_path__ + "static/media/stats3.6a1a9c57386f388e23b64a21c468d32e.svg";
export { ForwardRef as ReactComponent };